/*
 * File: /src/store/modules/leadCategory.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import LeadCategoryService from 'src/services/leadCategoryService';

const state = {
  leadCategories: undefined
};

const getters = {
  getLeadCategories: (state) => state.leadCategories,
};
const actions = {
  async fetchLeadCategories({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.leadCategories == undefined) {
      return LeadCategoryService.fetchAll()
      .then(r => {
        commit('setLeadCategories', r.data);
      });
    }
  },
  unloadLeadCategories({ commit }) {
    commit('setLeadCategories', undefined);
  }
};
const mutations = {
  setLeadCategories(state, categories) {
    state.leadCategories = categories;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
